/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { StructuredAnalysisResponseData } from './StructuredAnalysisResponseData';
import {
    StructuredAnalysisResponseDataFromJSON,
    StructuredAnalysisResponseDataFromJSONTyped,
    StructuredAnalysisResponseDataToJSON,
} from './StructuredAnalysisResponseData';

/**
 * 
 * @export
 * @interface StructuredAnalysisResponse
 */
export interface StructuredAnalysisResponse {
    /**
     * 
     * @type {string}
     * @memberof StructuredAnalysisResponse
     */
    status?: StructuredAnalysisResponseStatusEnum;
    /**
     * 
     * @type {StructuredAnalysisResponseData}
     * @memberof StructuredAnalysisResponse
     */
    data?: StructuredAnalysisResponseData;
}


/**
 * @export
 */
export const StructuredAnalysisResponseStatusEnum = {
    Success: 'SUCCESS',
    InsufficientData: 'INSUFFICIENT_DATA',
    AiDetected: 'AI_DETECTED',
    AgentError: 'AGENT_ERROR',
    OutsideBusinessHours: 'OUTSIDE_BUSINESS_HOURS',
    SystemUnavailable: 'SYSTEM_UNAVAILABLE',
    MemberNotFound: 'MEMBER_NOT_FOUND',
    InvalidOrMissingInformation: 'INVALID_OR_MISSING_INFORMATION',
    IncorrectPayorSetup: 'INCORRECT_PAYOR_SETUP'
} as const;
export type StructuredAnalysisResponseStatusEnum = typeof StructuredAnalysisResponseStatusEnum[keyof typeof StructuredAnalysisResponseStatusEnum];


/**
 * Check if a given object implements the StructuredAnalysisResponse interface.
 */
export function instanceOfStructuredAnalysisResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StructuredAnalysisResponseFromJSON(json: any): StructuredAnalysisResponse {
    return StructuredAnalysisResponseFromJSONTyped(json, false);
}

export function StructuredAnalysisResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StructuredAnalysisResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': !exists(json, 'status') ? undefined : json['status'],
        'data': !exists(json, 'data') ? undefined : StructuredAnalysisResponseDataFromJSON(json['data']),
    };
}

export function StructuredAnalysisResponseToJSON(value?: StructuredAnalysisResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'data': StructuredAnalysisResponseDataToJSON(value.data),
    };
}

